import React from "react";
import { useEffect, useState } from "react";
// import { useAuthContext } from "../../../hooks/useAuthContext";
import "./Galeria.css";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

// import Swiffy Slider CSS

export default function Galeria() {
//   const { register } = useAuthContext();
  const [images, setImages] = useState([
    "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
    "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
    "/images/ProximamenteR.jpg",
  ]);
  useEffect(() => {
    if (images.length < 10) {
      for (let index = images.length; index < 10; index++) {
        setImages(images.push("/images/ProximamenteR.jpg"));
      }
    }
    setImages(images);
  }, [images]);
  return (
    <div className="row">
      <h1 className="page-title">GALERIA</h1>
      <div className="container">
        <h2 className="page-title">CARTELES</h2>
        <Slide slidesToScroll={1} slidesToShow={5}>
          {images.map((val, key) => {
            return (
              <div className="each-slide-effect">
                <div
                  key={key}
                  style={{
                    backgroundImage: `url(${val})`,
                    backgroundPositionX: `center`,
                  }}
                ></div>
              </div>
            );
          })}
        </Slide>
        <br />
        <br />
        <h2 className="page-title">DIPTICOS</h2>
        <Slide slidesToScroll={1} slidesToShow={5}>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[0]})` }}></div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[1]})` }}>
              <span>Slide 2</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[2]})` }}>
              <span>Slide 3</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[3]})` }}>
              <span>Slide 4</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[4]})` }}>
              <span>Slide 5</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[5]})` }}>
              <span>Slide 6</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[6]})` }}>
              <span>Slide 7</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[7]})` }}>
              <span>Slide 8</span>
            </div>
          </div>
          <div className="each-slide-effect">
            <div style={{ backgroundImage: `url(${images[8]})` }}>
              <span>Slide 9</span>
            </div>
          </div>
        </Slide>
      </div>
    </div>
  );
}
